import { useState } from "react";
import {
    OverviewCardWrapper,
    OverviewCardTop,
    SelectContainer,
    Hr
} from '../dashboard-overview.style'
import TasksChart from "./chart";

const TasksPending = () => {
    const [sort, setSort] = useState('');

    const handleChange = (event) => {
        console.log(event.target.value)
        setSort(event.target.value);
    };
    return (
        <OverviewCardWrapper>
            <OverviewCardTop>
                <span>
                    Tasks Pending
                </span>
                <SelectContainer>
                    <select onChange={handleChange}>
                        <option value="">Sort by</option>
                        <option value="date">Date</option>
                        <option value="time">Time</option>
                        <option value="day">Day</option>
                    </select>
                </SelectContainer>
            </OverviewCardTop>
            <Hr />
            <TasksChart />
        </OverviewCardWrapper>
    )
}

export { TasksPending }
